import {useEffect, useState} from 'react';
import { useCameraKit } from './hooks/useCameraKit';
import LensSelector from "./components/lens-selector/lens-selector";
import PoweredBy from "./components/powered-by/powered-by";
import SharingScreen from "./components/sharing-screen/sharing-screen";
import SplashScreen from "./components/splash-screen/splash-screen";
import CaptureSwitcher from "./components/captupe-switcher/capture-switcher";
import './app-ui.css';
import {
    CAPTURE_METHOD, MAX_RECORD_DURATION, VIDEO_RECORDING_CONTENT_TYPE, START_RECORDING_PERCENT_FROM
} from "./constants";

function AppUI({ showDebug }) {
  const {
      isStarting, lenses, lensIndex, changeLens, camera, toggleCamera, isApplyingLens
  } = useCameraKit();

  const [ sharedBlob, setSharedBlob ] = useState(null);
  const [ width, setWidth ] = useState(`${window.innerWidth}px`);
  const [ height, setHeight ] = useState(`${window.innerHeight}px`);
  const [ captureMethod, setCaptureMethod ] = useState(CAPTURE_METHOD.PHOTO);
  const [ recording, setRecording ] = useState(false);
  const [ recordingPercents, setRecordingPercents ] = useState(START_RECORDING_PERCENT_FROM);
  const [ recordingTimer, setRecordingTimer ] = useState(0);
  const [ mediaRecorderRef, setMediaRecorderRef ] = useState(null);

  function capture(e, cancel = false) {
      if (e.target.nodeName !== 'DIV' || !e.target.classList.contains('active-lens')) return;
      try {
          const liveRenderTarget = document.querySelector('.app-container canvas');
          const style = window.getComputedStyle(liveRenderTarget);
          showDebug(`PHOTO/VIDEO ${style.width}x${style.height}`);
          setWidth(style.width);
          setHeight(style.height);

          if (captureMethod === CAPTURE_METHOD.PHOTO) {
              liveRenderTarget.toBlob((blob) => setSharedBlob(blob), "image/png");
          }
          else if (captureMethod === CAPTURE_METHOD.VIDEO && !cancel) {
              clearInterval(recordingTimer);
              const intervalStep = 100;
              let duration = 0;
              const mediaStream = liveRenderTarget.captureStream(30);

              if (!MediaRecorder.isTypeSupported(VIDEO_RECORDING_CONTENT_TYPE)) {
                  return showDebug(`Your device does not support ${VIDEO_RECORDING_CONTENT_TYPE} codec`);
              }
              const mediaRecorder = new MediaRecorder(mediaStream, {
                  mimeType: VIDEO_RECORDING_CONTENT_TYPE
              });
              mediaRecorder.addEventListener('dataavailable', e => {
                  if (!e.data.size) return showDebug('No recorded data available');
                  const blob = new Blob([e.data]);
                  showDebug(blob ? 'blob' : 'no blob');
                  setSharedBlob(blob);
              });
              mediaRecorder.start();
              setRecording(true);

              const recTimer = setInterval(() => {
                  if (duration > MAX_RECORD_DURATION) {
                      clearInterval(recTimer);
                      mediaRecorder.stop();
                      setRecording(false);
                      setRecordingPercents(START_RECORDING_PERCENT_FROM);
                      return;
                  }
                  setRecordingPercents(100 / MAX_RECORD_DURATION * duration);
                  duration += intervalStep;
              }, 100);

              setRecordingTimer(recTimer);
              setMediaRecorderRef(mediaRecorder);

          }
          else if (captureMethod === CAPTURE_METHOD.VIDEO && cancel) {
              clearInterval(recordingTimer);
              setRecordingPercents(START_RECORDING_PERCENT_FROM);
              mediaRecorderRef.stop();
              setRecording(false);
          }
      } catch (error) {
          console.error(error);
          showDebug(error.message);
      }
  }

  useEffect(() => {
      document.querySelectorAll('.capture-switcher-container .swiper-slide').forEach(el => {
          el.style.visibility = recording ? 'hidden' : 'visible';
      });
      document.querySelectorAll('.lenses-swiper-container .swiper-slide:not(.swiper-slide-active)').forEach(el => {
          el.style.visibility = recording ? 'hidden' : 'visible';
      });
  }, [ recording ]);

  return isStarting ? <SplashScreen /> : (<>
      <div className="dior-logo-top"></div>
      <button onClick={toggleCamera} className={'switcher-camera' + (recording ? ' hidden' : ' visible')}></button>

      {/* CaptureSwitcher component removed to hide it in all modes */}
      {/* <CaptureSwitcher captureMethod={captureMethod}
                       toggleCaptureMethod={setCaptureMethod}
      /> */}

      <LensSelector lenses={lenses}
                    lensIndex={lensIndex}
                    setLensIndex={changeLens}
                    shareContent={setSharedBlob}
                    captureMethod={captureMethod}
                    capture={capture}
                    recording={recording}
                    recordingPercents={recordingPercents}
      />
      <div className={"lens-loader" + (isApplyingLens ? " visible" : " hidden")}>
          <div className="dot-pulse "></div>
      </div>
      {/* <PoweredBy /> */}
      {sharedBlob && <SharingScreen sharedBlob={sharedBlob}
                                    close={() => setSharedBlob(null)}
                                    showDebug={showDebug}
                                    width={width}
                                    height={height} />}
  </>);
}

export default AppUI;
